export enum NotificationType {
  bidUpdated = 'bidUpdated',
  bidAccepted = 'bidAccepted',
  bidDeclined = 'bidDeclined',
  createDrayage = 'createDrayage',
  documentSigned = 'documentSigned',
  documentSignedRate = 'documentSignedRate',
  documentsAccepted = 'documentsAccepted',
  documentDeclined = 'documentDeclined',
  documentSignedDrayage = 'documentSignedDrayage',
  documentsAcceptedDrayage = 'documentsAcceptedDrayage',
  driverChanged = 'driverChanged',
  newAgreementUploaded = 'newAgreementUploaded',
  quickbooksAuthUrl = 'quickbooksAuthUrl',
  shipment = 'shipment',
  shipmentCreated = 'shipmentCreated',
  shipmentStageChange = 'shipmentStageChange',
  shipmentReadyForPickup = 'shipmentReadyForPickup',
  shipmentInfoUpdatedDrayage = 'shipmentInfoUpdatedDrayage',
  containerUpdatedDrayage = 'containerUpdatedDrayage',
  steamshipUpdatedDrayage = 'steamshipUpdatedDrayage',
  driverAssigned = 'driverAssigned',
  auctionStartDrayage = 'auctionStartDrayage',
  newAgreementAccepted = 'newAgreementAccepted',
  agreementDrayage = 'agreementDrayage',
  bidDeclinedDrayage = 'bidDeclinedDrayage',
  trackingDrayage = 'trackingDrayage',
  trackingDrayageSilent = 'trackingDrayageSilent',
  informationEditDrayageSilent = 'informationEditDrayageSilent',
  informationEditDrayage = 'informationEditDrayage',
  bidAcceptedDrayageLog = 'bidAcceptedDrayageLog',
  driverAssignedLog = 'driverAssignedLog',
  deliveredDrayage = 'deliveredDrayage',
  editedServicesPaymentTableDrayageDetails = 'editServicesDrayages',
  invoiceConfiguration = 'invoiceConfiguration',
  complementoPago = 'complementoPago',
  acceptedServicesDrayages = 'acceptedServicesDrayages',
  documentExtra = 'documentExtra',
  deleteDocumentExtra = 'deleteDocumentExtra',

  DrayageCSVUpdated = "drayageCSVUpdated",
  DrayageCSVRowUpdated = "drayageCSVRowUpdated",

  LoadLocationCreated = "loadLocationCreated",
  LoadLocationUpdated = "loadLocationUpdated",
  LoadLocationDeleted = "loadLocationDeleted",

  DrayagePositionUpdated = "drayagePositionUpdated",

  PolicyExpiring = "policyExpiring",
}
